import cn from "classnames"
import { Link } from "react-router-dom"

import style from "modules/ClientAccount/components/Selections/components/ItemWithPagination/style.module.scss"
import { formatToDayAndMonth } from "utils/datetime-format-utils"
import { Icon } from "components"
import { getFaceUrl } from "utils/helpers/psychologistUtil"
import { SelectionsResponse } from "modules/ClientAccount/utils"
import { Text } from "ui-kit/components-branded"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

interface Props {
    item: SelectionsResponse
}

export const ItemWithPagination = ({ item }: Props) => {
    const url = new URL(item.results_link)

    function onClick() {
        SurveyResultsStorage.storePartial({
            reported_problems_id: item.reported_problems.map((i) => +i),
        })
    }

    return (
        <Link
            className={style.item}
            to={{
                pathname: url.pathname,
                search: `${url.search}&subject=${item.subject}&reported_problems=${item.reported_problems.join(",")}`,
            }}
            onClick={onClick}
        >
            <div>
                {item.timestamp && (
                    <Text
                        className={cn(style.date, {
                            [style.dateMarginBottom]: !item.top_competence,
                        })}
                    >
                        {formatToDayAndMonth(new Date(item.timestamp))}
                    </Text>
                )}
                {item.top_competence && <Text className={style.title}>{item.top_competence}</Text>}
                {item.face_urls.length > 0 && (
                    <div className={style.faces}>
                        {item.face_urls.map((img, index) => (
                            <div className={style.face} key={index}>
                                <img className={style.faceImg} src={getFaceUrl(img)} alt="" />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Icon type="arrow-right-gray" size={24} />
        </Link>
    )
}
